import React, { Fragment } from 'react'
import PropTypes from 'prop-types'
import { inject, observer } from 'mobx-react'
import { withProps, withHandlers, compose } from 'recompose'
import { FilterUrl } from '../../../Svg/index'
import Dropdown from '../../../Shared/Dropdown'
import PropertyDetails from './PropertyDetails'

const enhance = compose(
  inject('store'),
  withProps(({ store }) => ({
    uiStateStore: store.uiStateStore,
    valueStateStore: store.valueStateStore,
    listingTypeStore: store.listingTypeStore
  })),
  withHandlers({
    onDropdownChange: ({ valueStateStore }) => (name, value) => {
      valueStateStore.setInputValue(name, value)
      valueStateStore.getSearchInfoDebounced()
    },
    onCheckboxChange: ({ valueStateStore }) => (name, value) => {
      valueStateStore.setInputValue(name, value)
      valueStateStore.getSearchInfoDebounced()
    }
  }),
  observer
)

const AdvancedFilter = ({
  submit,
  reset,
  cancelDropdown,
  registerDropdown,
  uiStateStore,
  valueStateStore,
  listingTypeStore,
  onActiveChanged,
  onDropdownChange,
  onCheckboxChange
}) => {
  const titleContent = (
    <Fragment>
      <div className='desktop-viewport'>
        More Filters
        <img src={FilterUrl} alt='More Filters' className='MoreFilters-icon'/>
      </div>
      <div className='tablet-viewport'>
        <img src={FilterUrl} alt='More Filters' style={{ aspectRatio: '20 / 17' }}/>
      </div>
    </Fragment>
  )

  return (
    <div className='AdvancedFilter'>
      <Dropdown
        id='advanced-filters'
        className='Dropdown--searchBar Dropdown--no-chevron'
        onActiveChanged={onActiveChanged}
        ref={(el) => {
          if (el) {
            el.setPreventClose = (ms) => {
              const preventCloseUntil = Date.now() + ms
              const wrapper = el?.controllerRef?.current?.parentElement ||
                             document.getElementById(el?.id || 'advanced-filters')?.closest('.Dropdown')
              if (wrapper) {
                wrapper._preventCloseUntil = preventCloseUntil
              }
            }
          }
          if (registerDropdown) {
            registerDropdown('advancedFilter', el)
          }
        }}
        title={titleContent}
      >
          <div className='Dropdown-container Dropdown-container--advanced'>
            <div className='AdvancedFilter-wrapper'>
              <div className='AdvancedFilter-content'>
                <PropertyDetails
                  valueStateStore={valueStateStore}
                  uiStateStore={uiStateStore}
                  listingTypeStore={listingTypeStore}
                  onDropdownChange={onDropdownChange}
                  onCheckboxChange={onCheckboxChange}
                />
              </div>
              <div className='AdvancedFilter-footer'>
                <button className='AdvancedFilter-clearButton' onClick={reset}>
                  Clear all Filters
                </button>
                <button className='AdvancedFilter-submitButton Button Button--primary' onClick={() => {
                  submit()
                  cancelDropdown && cancelDropdown()
                }}>
                  Show Homes ({valueStateStore.countResults})
                </button>
              </div>
            </div>
          </div>
        </Dropdown>
    </div>
  )
}

AdvancedFilter.propTypes = {
  cancelDropdown: PropTypes.func,
  listingTypeStore: PropTypes.shape({
    current: PropTypes.string
  }),
  onActiveChanged: PropTypes.func,
  onCheckboxChange: PropTypes.func.isRequired,
  onDropdownChange: PropTypes.func.isRequired,
  registerDropdown: PropTypes.func,
  reset: PropTypes.func.isRequired,
  submit: PropTypes.func.isRequired,
  uiStateStore: PropTypes.shape({
    closeModal: PropTypes.func.isRequired,
    isActive: PropTypes.bool.isRequired,
    openModal: PropTypes.func.isRequired
  }).isRequired,
  valueStateStore: PropTypes.shape({
    countResults: PropTypes.number
  }).isRequired
}

export default enhance(AdvancedFilter)

